import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { SUPPLIERS_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getSuppliersAction = createAsyncThunk(
    'store/getSuppliersAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ SUPPLIERS_PATH }${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getSuppliersSlice = createSlice({
    name: 'getSuppliersSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getSuppliersAction.pending, () => STATE__API__STARTED);
        builder.addCase(getSuppliersAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getSuppliersAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getSuppliersState = (state) => state.store.getSuppliers;
export default getSuppliersSlice.reducer;
